import { useEffect, useRef, useState } from "react";
import { Row, Col, Flex, Dropdown, Button, Input, Drawer, Typography, Modal, Avatar } from "antd";
import { CloseOutlined, MenuFoldOutlined, MenuUnfoldOutlined, PhoneFilled, PhoneOutlined } from "@ant-design/icons";
import ProfileMenu from "./models/ProfileMenu";
import LinkedProductsLauncher from "./LinkedProductsLauncher";
import ProfileModal from "./models/ProfileModal";
import UserStatusHandler from "./UserStatusHandler";
import EconnectLogo from "../../assets/images/logos/EconnectLogo";
import { setSearchModal, setSearchModalExpand, setSearchMsgText } from "../../store";
import Sidebar from "../Sidebar";
import { useChatUserStore, useUserSelfStore } from "../../store/apis/useUserStore";
import { useBridgeStore } from "../../store/apis/useBridgeStore";
import { useNavigate, useParams } from "react-router-dom";
import { useChannelStore } from "../../store/apis/useChannelStore";
import { useVideoCall } from "../VideoChat/VideoCallProvider";
import { useSocket } from "../../Context/SocketContext";
import { useSocketListener } from "../../socket/hooks/useSocketListener";
import "../VideoChat/VideoChat.css"

const Header = () => {

  const { channelId } = useParams();
  
  const navigate = useNavigate();
  const callNotificationRef = useRef(null);
  const ringtoneRef = useRef(null);
  


  const { incomingCall, rejectCall, setIncomingCall, socket, setInCall, inCall } = useSocket();
  
  const UserData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  const [companyLogoUrl, setcompanyLogoUrl] = useState(localStorage.getItem("companyLogoUrl") == undefined ? null : localStorage.getItem("companyLogoUrl"))
  const [companyFavIcoUrl, setcompanyFavIcoUrl] = useState(localStorage.getItem("companyFavIcoUrl"))
  const [isSetCustomStatusModalOpen, setIsSetCustomStatusModalOpen] = useState(false);
  const channelData = useChannelStore((state) => state.channelData);
  const chatUserData = useChatUserStore((state) => state.chatUserData);

  const userSelfData = useUserSelfStore((state) => state.userSelfData);
  const setSearchParticularRecord = useBridgeStore(state => state.setSearchParticularRecord)
  const hangUp = useBridgeStore(state => state.hangUp)
  const setSearchMsgText = useBridgeStore(state => state.setSearchMsgText)
  const setGlobalSectionConfig = useBridgeStore((store) => store.setGlobalSectionConfig)

  const [toggleSearchMsg, setToggleSearchMsg] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchInputRef = useRef();
  const [theme, setTheme] = useState("light");
  const [openSidebarMenu, setOpenSidebarMenu] = useState(false);
  const [placement, setPlacement] = useState("left");
  const [toggle, setToggle] = useState(false);
  const [peerTopbarMicOn, setPeerTopbarMicOn] = useState(true)
  const [peerTopbarCameraOn, setPeerTopbarCameraOn] = useState(true)
  const [imageError, setImageError] = useState(false);


  // Request permission for notifications
  useEffect(() => {
    if ('Notification' in window && Notification.permission !== 'granted') {
      Notification.requestPermission().then(permission => {
        if (permission !== 'granted') {
          console.warn('🔕 Notifications disabled by user');
        }
      });
    }
  }, []);


  useEffect(() => {
    const requestNotificationPermission = async () => {
      if ('Notification' in window) {
        if (Notification.permission === 'default') {
          const permission = await Notification.requestPermission();
          return permission === 'granted';
        }
        return Notification.permission === 'granted';
      }
      return false;
    };

    const showCallNotification = async () => {
      console.log("Incoming call:", incomingCall);
      if (incomingCall) {
        const hasPermission = await requestNotificationPermission();
        console.log("Incoming call22:", incomingCall);
        if (hasPermission) {
          const notification = new Notification('Incoming Call', {
            body: `${incomingCall.name || 'Someone'} is calling you`,
            icon: '/logo192.png', // You can replace with your app's logo or avatar
            tag: 'incoming-call',
            requireInteraction: true,
          });

          callNotificationRef.current = notification;

          notification.onclick = () => {
            window.focus();
            notification.close();
          };

          notification.onclose = () => {
            console.log('🔕 Call notification closed');
          };
        }
      }
    };

    showCallNotification();

    return () => {
      if (callNotificationRef.current) {
        callNotificationRef.current.close();
        callNotificationRef.current = null;
      }
      setPeerTopbarCameraOn(true);
    };
  }, [incomingCall]);

  


  useEffect(() => {
    if (!socket) return;
    // Log when socket is connected
    socket.on('connect', () => {
      console.log('Socket connected with ID:', socket.id);
    });

    socket.on('callRejected', () => {
      setIncomingCall(null);
    }); // already in videochat


    const handleHangUp = () => {
      console.log("📴 Call ended by remote user");
      setIncomingCall(null);
      stopRingtone();
    };
     

    socket.on('userBusy', ({ toUserId }) => {
      console.log(`User ${toUserId} is busy`);
      setIncomingCall(null); // Ensure no stale incoming call state
      stopRingtone();
    });
  
    return () => {
      socket.off('hangUp', handleHangUp);
      socket.off('userBusy');
      setPeerTopbarCameraOn(true)
      stopRingtone();
    };
  }, [socket]);

  useEffect(() => {
    console.log("hsfbsh")
    setIncomingCall(null);
      stopRingtone();
  }, [hangUp])

  const closeCallNotification = () => {
    if (callNotificationRef.current) {
      callNotificationRef.current.close();
      callNotificationRef.current = null;
    }
  }
  useEffect(() => {
    if (incomingCall) {
      ringtoneRef.current = new Audio('/ringtone/notificationCall.mp3');
      ringtoneRef.current.loop = true;
      ringtoneRef.current.play().catch((err) => {
        console.error("🔇 Could not play ringtone:", err);
      });
    } else {
      if (ringtoneRef.current) {
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
      }
    }
    // Stop ringtone on unmount
    return () => {
      if (ringtoneRef.current) {
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
      }
    };
  }, [incomingCall]);






  // stopRingtone function when call is accepted or rejected
  const stopRingtone = () => {
    console.log("Stopping ringtone...");
    if (ringtoneRef.current) {
      ringtoneRef.current.pause();
      ringtoneRef.current.currentTime = 0;
    } else {
      console.log("Ringtone ref is not set.");
    }
  };


  const handleAccept = () => {
    const { fromUserId, signal, discussionId, name, cameraOn: peerCameraInitial, micOn: peerMicInitial } = incomingCall;
    console.log("Incoming call detailssqssqs:", incomingCall, peerCameraInitial, peerMicInitial)

    if (discussionId && fromUserId && signal) {

      // window.history.pushState({
      //   pathname: `/video-call`,
      //   state: {
      //     fromUserId, signal, discussionId, name, from: window.location.pathname,
      //     // Make sure to use the values from incomingCall if available, otherwise fallback to state values
      //     cameraOn: typeof peerCameraInitial === 'boolean' ? peerCameraInitial : peerTopbarCameraOn,
      //     micOn: typeof peerMicInitial === 'boolean' ? peerMicInitial : peerTopbarMicOn

      //   },
      // });
      
      // setIncomingCall(null);
      navigate('/video-call', {
        state: {
          fromUserId,
          signal,
          discussionId,
          name,
          from: window.location.pathname,
          cameraOn: typeof peerCameraInitial === 'boolean' ? peerCameraInitial : peerTopbarCameraOn,
          micOn: typeof peerMicInitial === 'boolean' ? peerMicInitial : peerTopbarMicOn
        }
      });
     
      closeCallNotification();
      setTimeout(() => setIncomingCall(null), 0);
    } else {
      console.error("Missing call details");
    }
  };


  //My code---
  function convertToUnderscore(input) {
    return input?.replace(/\s+/g, '_');
  }
  const individualSearchLogic = () => {
    console.log(channelData,"channelData",channelId)
    let oppositeUserChannelRawData = channelId ? channelData : chatUserData;
    if (!oppositeUserChannelRawData) return;
    let parsedData = oppositeUserChannelRawData

    let name = parsedData?.userName ? parsedData?.userName : parsedData?.channelName
    setSearchText(`in:@${convertToUnderscore(name)} `)
    setSearchParticularRecord({ name, id: parsedData._id, isChannel: parsedData?.userName ? false : true })
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  const handleCtrlF = (event) => {
    // Check for CTRL + F key combination
    if (event.ctrlKey && event.key === "f") {
      event.preventDefault();
      individualSearchLogic();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleCtrlF);
    return () => window.removeEventListener("keydown", handleCtrlF);
  }, [handleCtrlF]);


  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
    const checkbox = document.getElementById("toggleBtn");
    if (checkbox) {
      if (savedTheme === "light") {
        checkbox.classList.add("light-mode");
        checkbox.classList.remove("dark-mode");
      } else {
        checkbox.classList.add("dark-mode");
        checkbox.classList.remove("light-mode");
      }
    }
  }, []);


  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme);
    const checkbox = document.getElementById("toggleBtn");
    if (newTheme === "light") {
      checkbox.classList.add("light-mode");
      checkbox.classList.remove("dark-mode");
    } else {
      checkbox.classList.add("dark-mode");
      checkbox.classList.remove("light-mode");
    }
  };

  const handleSearch = () => {
    setSearchMsgText({ value: searchText, timestamp: new Date() });
    // setSearchModal(true);
    // setSearchModalExpand(false);
    setGlobalSectionConfig({ openedSection: "MessageSearchSection", isExpanded: false })
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };


  const showSidebarMenu = () => {
    setOpenSidebarMenu(true);
    setToggle(true);
  };

  const onClose = () => {
    setOpenSidebarMenu(false);
    setToggle(false);
  };

  console.log("Header component rendered with UserData:", incomingCall, !inCall, incomingCall?.fromUserId, UserData?._id);
  return (
    <>
      <Row className="header-wrapper">
        <Col flex="auto">
          <Flex align="center" gap="small">
            <Flex align="center" className="change-chat-prev-next">
              <button className="btn-prev" onClick={ showSidebarMenu }></button>
              <div className="channel-wrapper">
                <Button type="text" onClick={ showSidebarMenu } className="sidebar-toggler">
                  { openSidebarMenu ? <MenuFoldOutlined /> : <MenuUnfoldOutlined /> }
                </Button>
                <Drawer
                  title={
                    <Flex vertical>
                      <Typography.Title level={ 5 } style={ { marginBottom: 0 } }>
                        { userSelfData?.fullName ? userSelfData?.fullName : userSelfData?.userName }
                      </Typography.Title>
                      <Typography.Text type="secondary" style={ { fontSize: "12px" } }>
                        { userSelfData?.email }
                      </Typography.Text>
                    </Flex>
                  }
                  placement={ placement }
                  closable={ false }
                  onClose={ onClose }
                  open={ toggle }
                  key={ placement }
                  className="mobile-drawer-sidebar"
                  width="250"
                >
                  <Flex vertical className="sidebar ant-layout-sider">
                    <Sidebar />
                  </Flex>
                </Drawer>
              </div>
            </Flex>
            { ((!toggleSearchMsg && window.innerWidth <= 500) || window.innerWidth > 500) && (
              <div className="sidebar-logo">
                { companyLogoUrl && !imageError ? (
                  <img
                    src={ `${companyLogoUrl}` }
                    alt="Company Logo"
                    onError={() => setImageError(true)}
                  />
                ) : (
                  <EconnectLogo />
                ) } 
              

              </div>
            ) }

            {/* {((!toggleSearchMsg && window.innerWidth <= 500) || window.innerWidth > 500) && (
              <div className="sidebar-logo">
                <EconnectLogo />
              </div>
            )} */}
          </Flex>
        </Col>
        <Col flex="auto">
          <Dropdown
            className="ec-dropdown header-search-dropdown"
            open={ isDropdownVisible }
            onOpenChange={ setIsDropdownVisible }
            dropdownRender={ () => (
              <Flex
                vertical
                gap="small"
                className="ec-dropdown__menu header-search-dropdown__menu"
              ></Flex>
            ) }
            trigger={ ["click"] }
          >
            <div
              className={ `search-container ${toggleSearchMsg ? "msgSearchOpen" : ""}` }
              onChange={ (e) => setSearchText(e.target.value) }
            >
              <Button
                onClick={ () => setToggleSearchMsg(true) }
                className="search-icon"
              >
                <i className="fa-solid fa-magnifying-glass"></i>
              </Button>
              <Input
                ref={ searchInputRef }
                type="text"
                className="custom-search"
                placeholder="Search"
                value={ searchText }
                onKeyPress={ handleKeyPress }
                onChange={ (e) => setSearchText(e.target.value) }
              />
              { searchText.length > 0 && (
                <div className="clear-search" onClick={ () => setSearchText("") }>
                  <CloseOutlined />
                </div>
              ) }
              <Button
                className="closeBtn"
                onClick={ () => {
                  searchText.length === 0 && setToggleSearchMsg(false);
                } }
              >
                <i className="fa-solid fa-circle-chevron-right"></i>
              </Button>
            </div>
          </Dropdown>
        </Col>
        <Col flex="auto">
          <Flex justify="end" align="center" gap="small" className="menu-controls">
            <div className="toggle-button">
              <input
                type="checkbox"
                className="checkbox"
                id="toggleBtn"
                checked={ theme === "dark" }
                onChange={ toggleTheme }
              />
              <label className="switch" htmlFor="toggleBtn">
                <i className="fas fa-moon"></i>
                <i className="fas fa-sun"></i>
              </label>
              <div className="ball"></div>
            </div>

            <LinkedProductsLauncher />
            <ProfileMenu socket={socket}/>
          </Flex>
        </Col>
      </Row>
      <ProfileModal userData={ UserData } />
      <UserStatusHandler userData={ userSelfData } />
      {console.log(incomingCall, inCall , incomingCall?.fromUserId , UserData?._id,"gddwdwdwdw")}
        <Modal

        width={400}
        className="imcoming-call-modal"
 open={incomingCall && !inCall && incomingCall.fromUserId !== UserData?._id}
          title={<Typography.Text type="danger">Incoming Call</Typography.Text>}
          footer={[
            <Button
              key="accept"
              type="primary"
              icon={<PhoneFilled />}
              onClick={() => {
                handleAccept()
                stopRingtone()
              }}
            >
              Accept
            </Button>,
            <Button
              key="decline"
              type="default"
              danger
              icon={<PhoneOutlined />}
              onClick={() => {
                rejectCall()
                stopRingtone()
                closeCallNotification()
              }}
            >
              Decline
            </Button>,
          ]}
          closable={false}
          maskClosable={false}
          keyboard={false}
          centered
        >
          <div style={{ textAlign: 'center' }}>
            <div style={{ position: 'relative', display: 'inline-block', marginBottom: 16 }}>
              <span className="pulse-animation" />
              <Avatar size={64}>
                {incomingCall?.name?.charAt(0).toUpperCase()}
              </Avatar>
            </div>
            <Typography.Title level={4} style={{ margin: 0 }}>
              {incomingCall?.name || incomingCall?.fromUserId}
            </Typography.Title>
            <Typography.Text type="secondary">is calling you...</Typography.Text>
          </div>
        </Modal>
    </>
  );
};

export default Header;